var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('b-card',[_c('h5',[_vm._v(_vm._s(_vm.$t('views.technicians.show.dispatcher.header')))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }